const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";

export function getPropertyImageUrl(imageName, options = {}) {
  if (!imageName) return "";

  const source = String(imageName).trim();
  if (!source) return "";

  if (/^https?:\/\//i.test(source)) {
    return source;
  }

  if (source.startsWith("/uploads/") || source.startsWith("/api/")) {
    return `${apiBaseUrl}${source}`;
  }

  const params = new URLSearchParams();
  if (options.width) params.set("width", String(options.width));
  if (options.height) params.set("height", String(options.height));
  if (options.quality) params.set("quality", String(options.quality));
  params.set("format", options.format || "webp");

  return `${apiBaseUrl}/api/images/properties/${encodeURIComponent(source)}?${params.toString()}`;
}